import React, { useState, forwardRef, useEffect } from 'react';

const CustomInput = forwardRef(({ 
  value,
  defaultValue = "",
  onChange,
  onFocus,
  onBlur,
  onUnfocus, // Custom prop for unfocus action
  className = "",
  ...props // All other standard input props
}, ref) => {
  // Internal state management
  const [internalValue, setInternalValue] = useState(defaultValue);

  // Determine if this is a controlled or uncontrolled component
  const isControlled = value !== undefined;
  const inputValue = isControlled ? value : internalValue;

  // Update internal value if defaultValue changes (for uncontrolled usage)
  useEffect(() => {
    if (!isControlled) {
      setInternalValue(defaultValue);
    }
  }, [defaultValue, isControlled]);

  const handleFocus = (e) => {
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e) => {
    if (onBlur) onBlur(e);
    
    // Custom unfocus action
    if (onUnfocus) {
      onUnfocus(inputValue, e);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    
    // Update internal state if uncontrolled
    if (!isControlled) {
      setInternalValue(newValue);
    }
    
    // Call external onChange if provided
    if (onChange) {
      onChange(newValue, e);
    }
  };

  return (
    <input
      ref={ref}
      value={inputValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={className}
      {...props}
    />
  );
});

CustomInput.displayName = 'CustomInput';

export default CustomInput;